import { type ForwardedRef, useImperativeHandle, useRef } from 'react';

export const useForwardRef = <T>(ref: ForwardedRef<T>, initialValue: null | T = null) => {
  const targetRef = useRef<T>(initialValue ?? null);

  useImperativeHandle(ref, () => targetRef.current as T, [targetRef]);
  return targetRef;
};
